import { NonPerformanceCodeForReportingCycle } from '@willow/graphql-iso/src/app';
import { getCurrentAndMaybePriorReportingCycles } from '@willow/types-iso';

export const getMostRelevantNonPerformanceReportingCycles = (
  nonPerformanceCodeForReportingCycle: NonPerformanceCodeForReportingCycle[],
  targetDate = new Date(),
) => {
  const reportingCycles = getCurrentAndMaybePriorReportingCycles(targetDate);
  return reportingCycles
    .map((cycle) =>
      nonPerformanceCodeForReportingCycle.find(
        (nph) => nph.cycle.year === cycle.year && nph.cycle.month === cycle.month,
      ),
    )
    .filter((entry) => entry !== undefined);
};
